export const getStoredToken = () => {
  const token = localStorage.getItem("token");

  if (!token || token === "undefined" || token === "null") {
    return null;
  }

  return token.replace(/^Bearer\s+/i, "");
};

export const getAuthHeaders = () => {
  const token = getStoredToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const persistAuthSession = (payload) => {
  const authData = payload?.data || payload || {};
  const token =
    authData.accessToken ||
    authData.token ||
    authData.access_token ||
    payload?.accessToken ||
    payload?.token;
  const name = authData.name || authData.user?.name || payload?.name || "Admin";

  if (!token) {
    throw new Error("Token tidak ditemukan pada response login");
  }

  localStorage.setItem("token", token.replace(/^Bearer\s+/i, ""));
  localStorage.setItem("name", name);
};
